import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDeleteStopCompareItems extends Layout {
    sourceEdiCompareItem: DataSource;
    tableCompareItems: Table;
}
